function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  version: "1.1",
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  x: "0",
  y: "0",
  viewBox: "0 0 40.14 40.14",
  xmlSpace: "preserve"
}, props), /*#__PURE__*/React.createElement("path", {
  className: styles["st0"] || "st0",
  d: "M24.26 15.72c-3.23-3.23-8.69-3.11-12.19.39l-8.65 8.65c-3.5 3.5-3.62 8.96-.39 12.19s8.69 3.11 12.19-.39c1.33-1.33 4.33-4.32 4.33-4.32.65-.65.65-1.71 0-2.36-.65-.65-1.71-.65-2.36 0l-4.33 4.33c-2.15 2.15-5.49 2.37-7.47.39s-1.76-5.32.39-7.47l8.65-8.65c2.15-2.15 5.49-2.38 7.47-.39.65.65 1.71.65 2.36 0 .65-.66.65-1.72 0-2.37z"
}), /*#__PURE__*/React.createElement("path", {
  className: styles["st0"] || "st0",
  d: "M15.61 24.37a8.367 8.367 0 005.9 2.45c2.21 0 4.34-.88 5.9-2.45l9.44-9.44a8.375 8.375 0 002.44-5.9c0-2.21-.88-4.34-2.44-5.9S33.16.69 30.95.69c-2.21 0-4.33.88-5.9 2.44l-4.72 4.72c-.65.65-.65 1.71 0 2.36.65.65 1.71.65 2.36 0l4.72-4.72c.94-.94 2.21-1.47 3.54-1.47s2.6.53 3.54 1.47 1.47 2.21 1.47 3.54-.53 2.6-1.47 3.54l-9.44 9.44c-.94.94-2.21 1.47-3.54 1.47s-2.6-.53-3.54-1.47c-.65-.65-1.71-.65-2.36 0-.65.65-.65 1.71 0 2.36z"
})));